<div class="row" [style.marginBottom.em]="1">
  <div class="col-3" *ngIf="showInterval">
    <select class="form-control" [formControl]="interval">
      <option value="days">By days</option>
      <option value="months">By months</option>
    </select>
  </div>
  <div class="col-3" *ngIf="interval.value === 'days'">
    <select class="form-control" [formControl]="period">
      <option value="30">Last month</option>
      <option value="90">Last 3 month</option>
      <option value="180">Last 6 month</option>
      <option value="365">Last 12 month</option>
    </select>
  </div>
</div>
<div class="row">
  <div class="col">
    <div class="card">
      <div class="card-body">
        <ma-chart
          [isLoading]="isLoading"
          [data]="slicedData$ | async"
          [label]="label"
        ></ma-chart>
      </div>
    </div>
  </div>
</div>
